export default __webpack_public_path__ + "static/media/MM.4b8f5eb8.svg";